import { render, staticRenderFns } from "./Formula.vue?vue&type=template&id=66beb952&"
import script from "./Formula.vue?vue&type=script&lang=js&"
export * from "./Formula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports